import { Empty } from "@p0security/ui";

export const NoContentFound: React.FC<{ description?: string }> = ({
  description,
}) => {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={description ?? "No options available"}
      className="text-center"
    />
  );
};
